import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает рекомендованные объявления
 */
export const selectOffersFromRecommendedApi = ({
  recommendedOffers: { offersFromRecommendedApi },
}: IApplicationState) => offersFromRecommendedApi.items;
